import axios from 'axios';
import auth from '@/auth/index';
import { API_BASEURL, API_BASEURL_V2 } from '@/config';

const axios_legacy_instance = axios.create({baseURL: API_BASEURL});
const axios_instance = axios.create({baseURL: API_BASEURL_V2, withCredentials: true});

//Set the authentication header
axios_legacy_instance.interceptors.request.use((config) => {
  const token = auth.getToken();
  if(!!token)
    config.headers.Authorization = 'WebApi ' + token;
  else
    delete config.headers.Authorization;

  return config;
})

const originalGet = axios_instance.get;

axios_instance.get = function(url, config) {
  config = config || {};
  config.withCredentials = true;
  return originalGet(url, config);
};

axios_instance.interceptors.request.use((config) => {
  config = config || {};
  config.withCredentials = true;
  return config;
},
  (error) => {
  return error;
});

axios_instance.interceptors.response.use((response) => {
  return response;
});
window.axios_instance = axios_instance;
export {
  axios_instance as axios,
  axios_legacy_instance as axios_legacy
}

export default axios_legacy_instance;
